import { type FC } from "react";
import { Heading } from "@clientFrontend/components/Heading";
import { Table } from "@root/shared/components/Table/Table";
import { Tr } from "@root/shared/components/Table/Tr";
import { Th } from "@root/shared/components/Table/Th";
import { Td } from "@root/shared/components/Table/Td";
import { ReadMoreButton } from "@root/shared/components/ReadMoreButton";
import { DeclineDetailsList } from "@clientFrontend/features/declineReport/components/UserDeclineReport/uiParts/declineDetailsList";
import { Icon } from "@root/shared/components/Icon";
import { Button } from "@root/shared/components/Button";
import { Label } from "@root/shared/components/Label";
import { type UserDeclineReportContent } from "./type";
import * as styles from "./styles.css";

type Props = {
  userDeclineReportContent: UserDeclineReportContent;
  isBiyo: boolean;
  linkToHomeHandler: () => void;
  linkToJobEntryIndexHandler: () => void;
  isDeclineDetailsNotEmpty: boolean;
  showDeclineDetailsReadMoreButton: boolean;
};

const DetailLabel = (label: string) => (
  <Label size="small" theme="lightGray">
    {label}
  </Label>
);

export const Presentation: FC<Props> = ({
  userDeclineReportContent,
  isBiyo,
  linkToHomeHandler,
  linkToJobEntryIndexHandler,
  isDeclineDetailsNotEmpty,
  showDeclineDetailsReadMoreButton,
}) => {
  return (
    <div>
      <section className={styles.section}>
        <Heading tag="h2" size="large" hasBorder isBiyo={isBiyo}>
          選考辞退数
        </Heading>
        <div className={styles.declineCountBox}>
          <span className={styles.declineCount}>{userDeclineReportContent.declineCount}</span>
          <span className={styles.declineCountText}>人</span>
        </div>
      </section>
      <section className={styles.section}>
        <Heading tag="h2" size="large" hasBorder isBiyo={isBiyo}>
          辞退理由の内訳
        </Heading>
        <Table className={styles.declineReasonTable} isSpHorizontal>
          {userDeclineReportContent.declineReasons.map((item) => (
            <Tr key={item.reason}>
              <Th width="700px" spWidth="237px" label={DetailLabel(item.label)}>
                {item.reason}
              </Th>
              <Td>{item.total}</Td>
            </Tr>
          ))}
        </Table>
      </section>
      <section className={styles.section}>
        {isDeclineDetailsNotEmpty && (
          <>
            <Heading tag="h2" size="large" hasBorder isBiyo={isBiyo}>
              辞退理由の詳細
            </Heading>
            <div className={styles.declineDescriptionWrapper}>
              {showDeclineDetailsReadMoreButton ? (
                <ReadMoreButton size="large">
                  <DeclineDetailsList declineDetails={userDeclineReportContent.declineDetails} />
                </ReadMoreButton>
              ) : (
                <DeclineDetailsList declineDetails={userDeclineReportContent.declineDetails} />
              )}
            </div>
          </>
        )}
        <div className={styles.noticeWrapper}>
          <h3 className={styles.noticeHead}>
            選考辞退を減らす
            <span className={styles.noticeStrong}>ために、これまでを振り返ってみましょう！</span>
          </h3>
          <div className={styles.noticeBox}>
            <div className={styles.noticeIcon}>
              <Icon name="light" />
            </div>
            <div>
              <h4 className={styles.noticeBoxHead}>
                採用率が高い企業は、応募から
                <span className={styles.noticeStrong}>3～6時間以内</span>
                に求職者様へ連絡をしています
              </h4>
              <p className={styles.noticeBoxBody}>応募からすぐにご連絡ができていますか…？</p>
            </div>
          </div>
          <div className={styles.noticeBox}>
            <div className={styles.noticeIcon}>
              <Icon name="light" />
            </div>
            <div>
              <h4 className={styles.noticeBoxHead}>
                応募者様の面接希望日を考慮して、
                <span className={styles.noticeStrong}>面接日時を設定</span>していますか？
              </h4>
              <p className={styles.noticeBoxBody}>
                応募日当日に面接予定日を確定することで、面接前キャンセルを防ぎやすくなります
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.buttonsWrapper}>
        <Button onClick={linkToHomeHandler} theme="tertiary" size="large" className={styles.button}>
          ホームに戻る
        </Button>
        <Button
          onClick={linkToJobEntryIndexHandler}
          theme="primary"
          size="large"
          className={styles.button}
        >
          応募一覧へ移動
        </Button>
      </div>
    </div>
  );
};
